import React, { useEffect, useRef, useState } from 'react'
import { randomColor } from '../../constants'
import { SpeakerBarProps } from '../../types/interface'
import styles from './Media.module.css'
import { getCookie } from '../../utils/common'


const SpeakerBar = ({ speakers, totalDuration, type, agentMessageCount, botMessageCount, customerMessageCount}: SpeakerBarProps) => {

    const tenantSlug = getCookie('current_tenant')

    const speakersKeys = speakers
    const progressBarRef = useRef(null)

    const [chatTotalCount, setChatTotalCount] = useState(0)

    useEffect(() => {
        if(type !== 'audio' && type !== 'email') {
            let chatCount = botMessageCount + agentMessageCount + customerMessageCount
            console.log(chatCount)
            setChatTotalCount(chatCount)
        }
    }, [])

    const seekBar = (type === 'audio') && speakersKeys.length && speakersKeys.map((speakerKey: string, i: any) => {
        if(speakerKey === 'agent' || speakerKey === 'customer') {
            return  <div className={`${styles.speakerBar} mt-4`} key={Math.random()}>
                    <div className="d-flex justify-content-between">
                        <h6>{ `${speakerKey} - ${speakers[speakerKey].name}` }</h6>
                        <span className={styles.totalDuration}>{Math.ceil(speakers[speakerKey].talktime/totalDuration*100)}%</span>
                    </div>
                    <div className={`${styles.speakerProgress} progress position-relative`} ref={progressBarRef}>
                        {
                            (speakers[speakerKey].transcripts).map((transcript: any) => {
                                let length = (transcript.end - transcript.start)/totalDuration*100
                                let offset = (transcript.start)/totalDuration*100
                                return <span key={Math.random()} style={{width: `${length}%`,left: `${offset}%`, backgroundColor: randomColor[i]}} className={styles.talkTime}></span>
                            })
                        }
                        
                    </div>
                </div>
        }
        return null
    })

    return (
        <div className={styles.speakerBarContainer}>
            { 
                type === 'audio' ?
                    seekBar :
                    (
                        type === 'chat' ?
                            <>
                                {
                                    customerMessageCount ?
                                        <div className={`${styles.speakerBar} mt-4`} key={Math.random()}>
                                            <div className="d-flex justify-content-between">
                                                <h6>{ `Customer - ${speakers.customer_name}` }</h6>
                                                <span className={styles.totalDuration}>{customerMessageCount}</span>
                                            </div>
                                            <div className={`${styles.speakerProgress} progress position-relative`}>
                                                {
                                                    customerMessageCount ?
                                                        <span key={Math.random()} style={{width: `${(customerMessageCount)/chatTotalCount*100}%`, backgroundColor: randomColor[0]}} className={styles.talkTime}></span> :
                                                        null
                                                }
                                            </div> 
                                        </div> :
                                        null
                                }
                                {
                                    botMessageCount ?
                                        <div className={`${styles.speakerBar} mt-4`} key={Math.random()}>
                                            <div className="d-flex justify-content-between">
                                                <h6>{ `Bot - ${speakers.bot_name}` }</h6>
                                                <span className={styles.totalDuration}>{botMessageCount}</span>
                                            </div>
                                            <div className={`${styles.speakerProgress} progress position-relative`}>
                                                {
                                                    botMessageCount ?
                                                        <span key={Math.random()} style={{width: `${(botMessageCount)/chatTotalCount*100}%`, backgroundColor: randomColor[1]}} className={styles.talkTime}></span> :
                                                        null
                                                }
                                            </div> 
                                        </div> :
                                        null
                                }
                                {
                                    agentMessageCount ?
                                        <div className={`${styles.speakerBar} mt-4`} key={Math.random()}>
                                            <div className="d-flex justify-content-between">
                                                <h6>{ `Agent - ${speakers.agent_name}` }</h6>
                                                <span className={styles.totalDuration}>{agentMessageCount}</span>
                                            </div>
                                            <div className={`${styles.speakerProgress} progress position-relative`}>
                                                {
                                                    agentMessageCount ?
                                                        <span key={Math.random()} style={{width: `${(agentMessageCount)/chatTotalCount*100}%`, backgroundColor: randomColor[2]}} className={styles.talkTime}></span> :
                                                        null
                                                }
                                            </div> 
                                        </div> :
                                        null
                                }
                            </> :
                            null
                    )
            }
        </div>
    )
}

export default SpeakerBar
